





import {defineComponent} from "@vue/composition-api";

export default defineComponent({
  name: "AtomImage",
  props: {
    url: {type: String},
    alt: {type: String},
  }
})
